import { makeVar } from "@apollo/client";

export const changeShareVar = makeVar<boolean>(false);
export const manageWatchListVar = makeVar<boolean>(false);
